import {getApiUrl} from "./client";
import {ALPHA_STATUS_ENDPOINT} from "./constants";

export type AlphaStatusResponse = {
    authorized: boolean;
    gateEnabled: boolean;
};

export type AlphaRedeemResponse = {
    success: boolean;
    authorized: boolean;
};

export type AlphaLogoutResponse = {
    success: boolean;
    revoked: boolean;
};

const LOCAL_ALPHA_HOSTNAMES = new Set([
    'localhost',
    '127.0.0.1',
    '::1',
    'redbridge'
]);

export const isLocalAlphaFrontendHost = (hostname: string = window.location.hostname) => {
    return LOCAL_ALPHA_HOSTNAMES.has(hostname.toLowerCase());
};

export const getAlphaStatus = async () => {
    const response = await fetch(getApiUrl(ALPHA_STATUS_ENDPOINT), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Accept': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error(`Alpha status request failed with ${response.status}`);
    }

    return await response.json() as AlphaStatusResponse;
};

export const redeemAlphaInvite = async (code: string) => {
    const response = await fetch(getApiUrl('/api/alpha/redeem'), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({code})
    });

    if (!response.ok) {
        let message = 'Invalid or unavailable invitation code.';

        try {
            const payload = await response.json();
            if (payload?.message) {
                message = payload.message;
            }
        } catch (error) {
            // Keep the generic invite error when the server response is not JSON.
        }

        throw new Error(message);
    }

    return await response.json() as AlphaRedeemResponse;
};

export const logoutAlphaSession = async () => {
    const response = await fetch(getApiUrl('/api/alpha/logout'), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error(`Alpha logout request failed with ${response.status}`);
    }

    return await response.json() as AlphaLogoutResponse;
};
